import {BookingRestriction} from "./types";

// With strict_minimum_per_booking off the minimum party size is waived for leftover
// capacity, so fewer places than the minimum are still bookable.
export const capacityIsBookable = (
    availableSlots: number,
    {minParticipants, strictMinimumPerBooking}: BookingRestriction
): boolean => availableSlots > 0 && (!strictMinimumPerBooking || availableSlots >= minParticipants);
